<template>
  <div>
    <el-form ref="claim" :model="item" label-width="120px" :label-position="labelPosition" size="small"
      v-loading="loading">
      <el-tabs v-model="activeName" plane>
        <el-tab-pane :label="$t('Məlumat')" name="claim">
          <div class="d-flex justify-content-center" style="padding-bottom: 10px"></div>
          <br />
          <card>
            <el-form label-width="200px" :label-position="labelPosition" size="small">
              <div class="row">
                <div class="col-md-4 col-12">
                  <span style=" font-size: var(--font-primary);">#: {{ item.claimNumber }}</span>
                </div>
                <div class="col-md-4 col-12">
                  <span style=" font-size: var(--font-primary);">{{
                    claimParticipants.participantType === 1
                      ? claimParticipants.policyNumber
                      : claimParticipants.participantTypeName
                    }}</span>
                </div>
                <div class="col-md-4 col-12">
                  <status-label :type="claimParticipants.statusTypeId === 45
                    ? 'indigo'
                    : '' || claimParticipants.statusTypeId === 50
                      ? 'forestGreen'
                      : '' || claimParticipants.statusTypeId === 70
                        ? 'goldenrod'
                        : '' || claimParticipants.statusTypeId === 75
                          ? 'limeGreen'
                          : '' || claimParticipants.statusTypeId === 80
                            ? 'mediumBlue'
                            : '' || claimParticipants.statusTypeId === 95
                              ? 'greenYellow'
                              : '' || claimParticipants.statusTypeId === 110
                                ? 'coral'
                                : '' || claimParticipants.statusTypeId === 125
                                  ? 'salmon'
                                  : '' || claimParticipants.statusTypeId === 130
                                    ? 'olive'
                                    : '' || claimParticipants.statusTypeId === 131
                                      ? 'lightblue'
                                      : '' || claimParticipants.statusTypeId === 135
                                        ? 'forestGreen'
                                        : '' || claimParticipants.statusTypeId === 140
                                          ? 'greenYellow'
                                          : '' || claimParticipants.statusTypeId === 141
                                            ? 'goldenrod'
                                            : ''
                    " />
                  {{ claimParticipants.statusTypeName }}
                </div>
              </div>
            </el-form>
          </card>
          <el-collapse v-loading="loading" value="1">
            <el-collapse-item name="1">
              <template slot="title" style="color: black;">
                <i class="fa-solid fa-people-group"></i>
                &nbsp;
                <span>{{$t('Hadisə_tərəfləri')}}</span>
              </template>
              <claim-participant-base :value="claimParticipants" />
            </el-collapse-item>
          </el-collapse>
          <el-collapse value="4" v-loading="loading">
            <el-collapse-item name="4">
              <template slot="title">
                <i class="fa-solid fa-circle-info"></i>
                &nbsp;
                <span>{{$t('Hadisə_məlumatları')}}</span>
              </template>
              <card>
                <el-form disabled label-width="200px" :label-position="labelPosition" size="small"
                  v-loading="claimLoading">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <el-form-item :label="$t('ZBT')" v-if="item.policyType && item.policyType === 1" prop="zbt">
                        <el-radio-group @change="radioChange('zbt')"
                          :disabled="item.commChainAccident === 1 || item.commInjured === 1" v-model="item.zbt">
                          <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                          <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item :label="$t('Zəncirvari_qəza')" v-if="item.policyType && item.policyType === 1"
                        prop="chainAccident">
                        <el-radio-group @change="radioChange('chainAccident')" :disabled="item.zbt === 1"
                          v-model="item.chainAccident">
                          <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                          <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item :label="$t('Xəsarət_alan')" v-if="item.policyType && item.policyType === 1"
                        prop="injured">
                        <el-radio-group @change="radioChange('injured')" :disabled="item.zbt === 1"
                          v-model="item.injured">
                          <el-radio :label="1">{{$t('Var')}}</el-radio>
                          <el-radio :label="0">{{$t('Yoxdur')}}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item :label="$t('Daxili_protokol')" v-if="item.policyType && item.policyType === 1"
                        prop="protocol">
                        <el-radio-group @change="radioChange('protocol')" :disabled="item.commInjured === 1"
                          v-model="item.protocol">
                          <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                          <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item :label="$t('Subroqasiya')" prop="subragation">
                        <el-radio-group @change="radioChange('subragation')" v-model="item.subragation">
                          <el-radio :label="1">{{$t('Var')}}</el-radio>
                          <el-radio :label="0">{{$t('Yoxdur')}}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item :label="$t('F4_verilmə_tarixi')" v-if="oSdamageType !== 2 && item.policyType === 1"
                        disabled prop="f4IssueDate">
                        <el-date-picker type="date" :placeholder="$t('F4_verilmə_tarixi')" v-model="item.f4IssueDate"
                          style="width: 100%"></el-date-picker>
                      </el-form-item>
                    </div>
                    <div class="col-md-6 col-12">
                      <el-form-item v-if="(item.paymentSum || item.paymentSum !== 0) && item.damageCategoryId !== 2"
                        :label="$t('Zərərçəkən_hər_iki_tərəf')" prop="bothVictim">
                        <el-checkbox :true-label="1" :false-label="0" v-model="item.bothVictim"></el-checkbox>
                      </el-form-item>
                      <el-form-item :label="$t('NV_sayı')" v-if="item.policyType && item.policyType === 1"
                        prop="vehicleCount">
                        <el-input-number :disabled="item.zbt === 1" v-model="item.vehicleCount" :min="1" :max="10" />
                      </el-form-item>
                      <el-form-item :label="$t('Hadisənin_səbəbi')" prop="damageCategoryId">
                        <damage-categories :damageType="claimParticipants.osDamageType"
                          v-model="item.damageCategoryId" />
                      </el-form-item>
                      <el-form-item :label="$t('Xəsarətin_dərəcəsi')" prop="medDamageType"
                        v-if="item.damageCategoryId === 2">
                        <med-damage-types v-model="item.medDamageType" />
                      </el-form-item>
                    </div>
                  </div>
                  <titles :text="$t('Faydalanan')"></titles>
                  <hr width="100%" size="50"
                    style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;" align="center">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <div style="display: flex;">
                        <div style="flex: 1; margin-right:-100px;">
                          <el-form-item>
                            <el-radio-group v-model="item.paymentPersonType">
                              <el-radio :label="1">{{$t('FİN')}}</el-radio>
                              <el-radio :label="2">{{$t('VÖEN')}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div style="flex: 1.2">
                          <el-form-item prop="paymentIdentNumber">
                            <el-input id="search" v-model="item.paymentIdentNumber" style="width: 100%;">
                              <span slot="append">&nbsp;</span>
                              <el-button class="primary" size="small" slot="append" icon="el-icon-search"
                                @click="item.paymentPersonType === 1 ? onSearchAsan('PersonalInfo') : onSearchAsan('VoenInfo')">
                              </el-button>
                            </el-input>
                          </el-form-item>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <el-form-item :label="$t('Faydalanan_şəxs')" prop="paymentReceivedPerson">
                        <el-input v-model="item.paymentReceivedPerson"></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-md-6 col-12">
                      <el-form-item :label="$t('Faydalananın_əlaqə_№')" prop="paymentReceivedPersonPhone">
                        <phone v-model="item.paymentReceivedPersonPhone" />
                      </el-form-item>
                    </div>
                  </div>
                  <titles v-if="item.damageCategoryId !== 1 && item.policyType === 1" text="Xəsarət alan"></titles>
                  <hr v-if="item.damageCategoryId !== 1 && item.policyType === 1" width="100%" size="50"
                    style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;" align="center">
                  <div class="row" v-if="item.policyType === 1">
                    <div class="col-md-6 col-12">
                      <el-form-item v-if="item.damageCategoryId && item.damageCategoryId !== 1"
                        ::label="$t('getIdentLabelName')" prop="identNumber">
                        <el-input id="search" v-model="item.partIdentNumber" style="width: 100%;">
                          <span slot="append">&nbsp;</span>
                          <el-button class="primary" size="small" slot="append" icon="el-icon-search"
                            @click="onSearchPersonalInfo">
                          </el-button>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div class="col-md-6 col-12">
                    </div>
                  </div>
                  <div class="row" v-if="item.policyType === 1">
                    <div class="col-md-6 col-12">
                      <el-form-item v-if="item.damageCategoryId && item.damageCategoryId !== 1"
                        ::label="$t('getPartPersonLabel')" prop="partPersonName">
                        <el-input v-model="item.partPersonName"></el-input>
                      </el-form-item>
                      <el-form-item
                        v-if="item.damageCategoryId && item.damageCategoryId !== 1 && item.damageCategoryId !== 2"
                        :label="$t('Əmlak_adı')" prop="propertyName">
                        <el-input v-model="item.propertyName"></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-md-6 col-12">
                      <el-form-item v-if="item.damageCategoryId && item.damageCategoryId !== 1"
                        ::label="$t('getPartPersonPhoneLabel')" prop="partPersonPhone">
                        <phone v-model="item.partPersonPhone" />
                      </el-form-item>
                    </div>
                  </div>
                  <titles text="Ödəniş məlumatları"></titles>
                  <hr width="100%" size="50"
                    style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;" align="center">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <el-form-item :label="$t('Ödənilmə_qaydası')" prop="paymentRule">
                        <el-select style="width: 100%" :placeholder="$t('Seçin')" size="small"
                          v-model="item.paymentRule">
                          <el-option :label="$t('Bank_hesabı')" :value="2"></el-option>
                          <el-option :label="$t('Kart')" :value="1"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="col-md-6 col-12">
                      <el-form-item :label="$t('Yekun_məbləğ')" prop="paymentSum">
                        <el-input v-decimal :disabled="true" v-model="item.paymentSum"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-12">
                      <el-form-item :label="$t('Əlavə_qeyd')" prop="otherDescr">
                        <el-input v-model="item.otherDescr" resize="none" type="textarea" :rows="2">
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>
                </el-form>
              </card>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-loading="loading" value="1">
            <el-collapse-item name="1">
              <template #title>
                <div style="margin-left: 7px;">
                  <i class="fa-solid fa-headphones-simple"></i>
                  &nbsp;
                  <span>{{$t('Çağrı_mərkəzinin_qeydləri')}}</span>
                </div>
              </template>
              <div v-if="accItem">
                <accident-base :value="accItem"></accident-base>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-loading="loading" value="2">
            <el-collapse-item name="2">
              <template slot="title">
                <i class="fa-solid fa-person-military-pointing"></i>
                &nbsp;
                <span>{{$t('Komissarın_qeydləri')}}</span>
              </template>
              <div v-if="comm">
                <accident-comm-base :value="comm"></accident-comm-base>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-loading="loading" value="3">
            <el-collapse-item name="3">
              <template #title>
                <div style="margin-left: 7px;">
                  <i class="fa-solid fa-people-arrows-left-right"></i>
                  &nbsp;
                  <span>{{$t('İştirakçılar')}}</span>
                </div>
              </template>
              <card>
                <el-form v-loading="partloading">
                  <div class="row">
                    <div class="col-md-6 col-12" v-for="item in participants" :key="item.id">
                      <participant-card :item="item" :readonly="true" @edit="editParticipant"
                        @report="reportParticipant" />
                    </div>
                  </div>
                </el-form>
              </card>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
        <el-tab-pane name="claimdoc" :label="$t('Sənədlər')">
          <div>
            <claim-docs :readonly="true" v-if="item.id" :id="item.id"></claim-docs>
          </div>
        </el-tab-pane>
        <el-tab-pane name="expert" v-if="oSdamageType !== 2" :label="$t('Qiymətləndirmə')">
          <div>
            <div class="row">
              <div class="col-md-10 col-12">
                <div style="padding-bottom: 10px">
                  <div v-if="this.techExpertStatus">
                    <span style="background-color:#8E9A9B; color: white; padding:5px;">{{
                      "İş texniki ekspertizaya göndərilmişdir: " +
                      techExpertStatus.createdBy
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="this.techExpertStatus">
              <assessments @refresh="getData" :claimId="Number(this.id)" :readonly="false" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="act" v-if="claimStatus >= 139" :label="$t('Hesab_məlumatları')">
          <div>
            <div class="row">
              <div class="col-10">
                <div v-if="act">
                  <span style="background-color:#8E9A9B; color: white; padding:5px;">{{
                    "Hesab məlumatlarının daxil edilməsi başlanmışdır: " +
                    act.createdBy
                    }}</span><br />
                </div>
              </div>
            </div>
            <div v-if="act">
              <bank-account-info :readonly="true" :value="act" @refresh="getData" :actPrint="actPrint"
                :policyType="item.policyType" />
            </div>
            <div class="row" style="text-align: right">
              <div class="col-12">
              </div>
            </div>
          </div>
          <br />
        </el-tab-pane>
        <el-tab-pane name="aprrove" :label="$t('Təsdiqlənmə')">
          <card v-if="claimStatus >= 150">
            <div>
              <div class="row">
                <div class="col-10">
                  <div v-if="claimStatus >= 150">
                    <i class="fa-solid fa-check"></i>
                    &nbsp;
                    <span style="background-color:#8E9A9B; color: white; padding:5px;">{{
                      "Təsdiqlənməyə göndərilmişdir " +
                      act.createdBy
                      }}</span><br />
                  </div>
                </div>
              </div>
              <br>
              <signers v-if="item.id" :value="item.id"></signers>
            </div>
          </card>
        </el-tab-pane>
        <el-tab-pane name="payment" :label="$t('Ödəniş')">
          <card>
            <div>
            </div>
          </card>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <participant ref="participant" @saved="getParticipants" />
    <report-participant ref="report" @saved="getParticipants" />
  </div>
</template>
<script>
import ClaimParticipantBase from "../components/ClaimParticipantBase.vue";
import Phone from "../components/Phone.vue";
import StatusLabel from "../components/StatusLabel.vue";
import DamageCategories from "../components/DamageCategories.vue";
import BankAccountInfo from '../components/BankAccountInfo.vue';
import ClaimDocs from "../components/ClaimDocs.vue";
import Signers from "../components/Signers.vue";
import Assessments from "../components/Assessments.vue";
import MedDamageTypes from "../components/MedDamageTypes.vue";
import ActPrint from "../components/ActPrint.vue";
import Participant from "../components/Participant.vue";
import ParticipantCard from "../components/ParticipantCard.vue";
import AccidentBase from "../components/AccidentBase.vue";
import AccidentCommBase from "../components/AccidentCommBase.vue";
import ReportParticipant from "../components/ReportParticipant.vue";
import { GetParticipants, GetAccidentsByStatus } from "../../services/accident";
import { asanapi } from "../../services/sales";
import { labelPosition } from "../../services/helper";
import {
  GetClaimParticipant,
  GetClaimActPrint,
  CheckStatusCount,
  LastAssessmentStatus,
} from "../../services/common";
import { GetAccident, GetCommData } from "../../services/accident";
import {
  GetClaim,
  UpdateClaim,
  DeleteClaimDoc,
  SendToTechExpert,
  GetClaimTechExpert,
  CreateClaimAct,
  GetClaimAct,
  SendToLegalExpert,
  LastClaimStatus,
  SendToApprove,
} from "../../services/claim";
import Titles from "../components/Titles.vue";
export default {
  components: {
    Titles,
    ClaimDocs,
    ClaimParticipantBase,
    StatusLabel,
    DamageCategories,
    BankAccountInfo,
    Signers,
    Assessments,
    MedDamageTypes,
    Phone,
    AccidentBase,
    AccidentCommBase,
    Participant,
    ReportParticipant,
    ParticipantCard,
  },
  props: {
    id: [String, Number],
  },
  data() {
    return {
      activeName: "claim",
      loading: false,
      claimLoading: false,
      item: {},
      participants: [],
      claimdocs: [],
      accItem: null,
      search: "",
      claimParticipants: {},
      fileStatus: 0,
      techExpertStatus: null,
      legalExpertStatus: null,
      expertItem: {},
      actLoading: false,
      act: null,
      actPrint: {},
      claimStatus: null,
      oSdamageType: 1,
      medExpert: {},
      statusCount: 0,
      uid: this.$store.state.user.id,
      asanData: {
        Personal: {},
        Voen: {},
      },
      assessmentStatus: null,
      printDialogVisible: false,
      comm: null,
      partloading: false,
      isDivided: false,
      paymentSum: null,
      labelPosition: labelPosition,
    };
  },
  computed: {
    paymentSumComputed: function () {
      const baseAmount = 5000;
      switch (this.item.medDamageType) {
        case 1:
          return (baseAmount * 15) / 100;
        case 2:
        case 3:
          return (baseAmount * 30) / 100;
        case 4:
          return (baseAmount * 100) / 100;
        case 5:
          return (baseAmount * 80) / 100;
        case 6:
          return (baseAmount * 60) / 100;
        case 7:
          return (baseAmount * 40) / 100;
        default:
          return 0;
      }
    },
    getPartPersonLabel() {
      if (this.item.damageCategoryId === 1) {
        return null;
      } else if (this.item.damageCategoryId === 2) {
        return this.$t('Xəsarətalanşəxs');
      } else {
        return this.$t('Əmlaksahibininadı');
      }
    },
    getIdentLabelName() {
      if (this.item.damageCategoryId === 1) {
        return null;
      } else if (this.item.damageCategoryId === 2) {
        return this.$t('XəsarətalanınFN');
      } else {
        return this.$t('ƏmlaksahibininFN');
      }
    },
    getPartPersonPhoneLabel() {
      if (this.item.damageCategoryId === 1) {
        return null;
      } else if (this.item.damageCategoryId === 2) {
        return this.$t('Xəsarətalanınəlaqənömrəsi');
      } else {
        return this.$t('Əmlaksahibininəlaqənömrəsi');
      }
    },
  },
  methods: {
    getClaimActPrint() {
      GetClaimActPrint(this.id).then((response) => {
        if (response.data) {
          this.actPrint = response.data.data?.[0];
        }
      });
    },
    onVictimChange(value) {
      if (value === 4) {
        this.paymentSum /= 2;
      } else {
        this.paymentSum = this.item.paymentSum;
      }
    },
    async print() {
      this.printDialogVisible = true;
    },
    async getCommData() {
      this.commloading = true;
      try {
        const response = await GetCommData(this.item.accidentId);
        this.comm = response.data.data?.[0] || null;
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Komissar_məlumatları_gətirilərkən_səhv_baş_verdi') });
        this.comm = null;
      } finally {
        this.commloading = false;
      }
    },
    async checkStatusCount(id, status) {
      this.statusCount = 0;
      try {
        const response = await CheckStatusCount(0, id, status);
        if (response.data) {
          this.statusCount = response.data;
        }
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Status_sayımı_gətirilərkən_səhv_baş_verdi') });
      }
    },
    editParticipant(id) {
      this.$refs["participant"].edit(id, true);
    },
    reportParticipant(id, accidentId, createUserId) {
      this.$refs["report"].edit(id, accidentId, createUserId);
    },
    async getClaimTechExpert() {
      try {
        const response = await GetClaimTechExpert(this.id);
        if (response.data) {
          this.expertItem = response.data.data?.[0];
          this.lastAssessmentStatus();
        }
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Texniki_ekspert_məlumatları_gətirilərkən_səhv_baş_') });
      }
    },
    async getClaimParticipants() {
      this.partloading = true;
      try {
        const response = await GetClaimParticipants(this.id);
        if (response.data) {
          this.claims = response.data.data;
        }
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Təminat_iştirakçıları_gətirilərkən_səhv_baş_verdi') });
      } finally {
        this.partloading = false;
      }
    },
    async getClaimAct() {
      try {
        const response = await GetClaimAct(this.id);
        this.act = response.data.data?.[0] || null;
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Hesab_məlumatları_gətirilərkən_səhv_baş_verdi') });
        this.act = null;
      }
    },
    async getStatusTechExpert() {
      try {
        const response = await GetAccidentsByStatus(0, this.id, 70, this.uid);
        this.techExpertStatus = response.data.data?.[0] || null;
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Texniki_ekspert_statusu_gətirilərkən_səhv_baş_verd') });
        this.techExpertStatus = null;
      }
    },
    async lastAssessmentStatus() {
      try {
        const response = await LastAssessmentStatus(this.id);
        this.assessmentStatus = response.data || null;
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Son_qiymətləndirmə_statusu_gətirilərkən_səhv_baş_v') });
        this.assessmentStatus = null;
      }
    },
    inputInsurance(e) {
      this.$emit("input", e);
      this.item.insuranceParticipantId = e;
    },
    inputOs(e) {
      this.$emit("input", e);
      this.item.osParticipantId = e;
    },
    async getParticipants() {
      this.partloading = true;
      try {
        const response = await GetParticipants(this.item.accidentId);
        if (response.data) {
          this.participants = response.data.data;
        }
      } catch (error) {
        this.$message({ type: "error", message: this.$t('ştirakçılar_gətirilərkən_səhv_baş_verdi') });
      } finally {
        this.partloading = false;
      }
    },
    checkServiceCenterId() {
      if (!this.participants || this.participants.length === 0) return false;
      const typeOneParticipants = this.participants.filter(
        (participant) => participant.participantType === 1
      );
      if (typeOneParticipants.length === 0) return false;
      const firstTypeOneParticipant = typeOneParticipants[0];
      return !!firstTypeOneParticipant.serviceCenterId;
    },
    saved() {
      this.getClaimDocs();
    },
    async getAccident() {
      try {
        const response = await GetAccident(this.item.accidentId);
        this.accItem = response.data.data?.[0] || null;
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Hadisə_məlumatları_gətirilərkən_səhv_baş_verdi') });
        this.accItem = null;
      }
    },
    async getData() {
      this.loading = true;
      try {
        const claimResponse = await GetClaim(this.id);
        if (!claimResponse.data || !claimResponse.data.data || claimResponse.data.data.length === 0) {
          this.$message({ type: "warning", message: this.$t('Təminat_məlumatları_tapılmadı') });
          this.loading = false;
          return;
        }
        this.item = claimresponse.data.data?.[0];
        this.paymentSum = this.item.paymentSum;
        await Promise.all([
          this.getAccident(),
          this.getCommData(),
          this.lastClaimStatus(),
          this.getParticipants(),
          this.getClaimParticipant(),
          this.getStatusTechExpert(),
          this.getClaimTechExpert(),
          this.getClaimAct(),
          this.getClaimActPrint(),
          this.lastAssessmentStatus()
        ]);
      } catch (error) {
        this.$message({ type: "error", message: "Bir səhv baş verdi: " + error.message });
      } finally {
        this.loading = false;
      }
    },
    async getClaimParticipant() {
      try {
        const response = await GetClaimParticipant(this.id);
        this.claimParticipants = response.data.data?.[0] || {};
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Təminat_iştirakçısı_məlumatları_gətirilərkən_səhv_') });
        this.claimParticipants = {};
      }
    },
    async lastClaimStatus() {
      try {
        const response = await LastClaimStatus(this.id);
        this.claimStatus = response.data || null;
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Son_təminat_statusu_gətirilərkən_səhv_baş_verdi') });
        this.claimStatus = null;
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>